import $ from 'jquery';

(function(){
    'use strict';

    var $subNav = $('.smp-subnav');

    if($subNav.length){

        $subNav.find('.smp-subnav__title button').each(function(){

            var $cur = $(this),
                $parentContainer = $cur.parent(),
                $parentLI = $cur.closest('li');

                $(this).click(function(){

                    if(!$parentContainer.hasClass('active')){
                        $parentLI.addClass('active');
                        $parentContainer.addClass('active');
                        $parentContainer.next('.smp-subnav__dropdown-wrapper').addClass('active');
                    }else {
                        $parentLI.removeClass('active');
                        $parentContainer.removeClass('active');
                        $parentContainer.next('.smp-subnav__dropdown-wrapper').removeClass('active');
                    }

                    return false;

                });

        });

    }

}());
